import { collection, onSnapshot } from 'firebase/firestore'
import { useDispatch, useSelector } from 'react-redux'
import { cmsAction, selectCms } from 'src/features/cms/cmsSlice'
import { fulfilled } from 'src/features/status'
import { db } from 'src/firebase/config'
import { useFireStore } from './useFireStore'

const useCms = () => {
  const dispatch = useDispatch()
  const { options } = useSelector(selectCms)
  const { getDocuments } = useFireStore()

  const loadProperties = async () => {
    const properties = await getDocuments('properties')

    dispatch(
      cmsAction.loadProperties({
        table: 'properties',
        items: properties.map((data) => ({
          ...data,
          // geopoint: {
          //   _lat: data.geopoint._lat,
          //   _long: data.geopoint._long,
          // },
        })),
        status: fulfilled,
      }),
    )
  }

  const syncOptions = () => {
    const systemRef = collection(db, 'system')
    return onSnapshot(systemRef, (querySnapshot) => {
      var items = []
      querySnapshot.forEach((doc, i) => {
        if (doc.exists) {
          items.push({
            ...doc.data(),
            id: doc.id,
          })
        }
      })
      dispatch(
        cmsAction.syncOptions({
          items: items, //.map((item) => ({ [item.id]: { ...item } })),
          status: fulfilled,
        }),
      )
    })
  }

  const syncNews = () => {
    const systemRef = collection(db, 'news')
    return onSnapshot(systemRef, (querySnapshot) => {
      var items = []
      querySnapshot.forEach((doc, i) => {
        if (doc.exists) {
          items.push({
            ...doc.data(),
            id: doc.id,
          })
        }
      })
      dispatch(
        cmsAction.syncNews({
          items: items, //.map((item) => ({ [item.id]: { ...item } })),
          status: fulfilled,
        }),
      )
    })
  }

  const getOption = (option) => {
    return (options || []).find((o) => o.id === option)
  }

  return {
    loadProperties,
    syncOptions,
    syncNews,
    getOption
  }
}

export { useCms }
